import { render, staticRenderFns } from "./LocalDispatch.vue?vue&type=template&id=3d9fa9d0&scoped=true&"
import script from "./LocalDispatch.vue?vue&type=script&lang=js&"
export * from "./LocalDispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9fa9d0",
  null
  
)

export default component.exports